<template>
  <div class="tsp-tax-card">
    <div class="tsp-tax-header">
      <div class="tsp-source">
        {{ $t('testingParty') }}
      </div>
      <div class="tsp-tax-col-wrapper" ref="headerColWrapper">
        <div class="tsp-tax-col">
          <span>{{ isSol ? $t('currentFee') : $t('tokenSecurityData.buyTax') }}</span>
          <el-tooltip popper-class="token-swap-popper" placement="top">
            <div slot="content" style="max-width: 200px">
              {{ $t('tokenSecurityData.buyTaxTip') }}
            </div>
            <img :src="queryIcon" alt="" />
          </el-tooltip>
        </div>
        <div class="tsp-tax-col" v-if="!isSol">
          <span>{{ $t('tokenSecurityData.sellTax') }}</span>
          <el-tooltip popper-class="token-swap-popper" placement="top">
            <div slot="content" style="max-width: 200px">
              {{ $t('tokenSecurityData.sellTaxTip') }}
            </div>
            <img :src="queryIcon" alt="" />
          </el-tooltip>
        </div>
      </div>
    </div>

    <div class="tsp-tax-body"  v-if="showGoPlus">
      <div class="tsp-source">
        <img class="platforms" :src="goPlusIcon" alt="" />
        <span> {{ 'GoPlus' }}</span>
      </div>
      <div class="tsp-tax-col-wrapper">
        <div class="tsp-tax-col" :style="bodyColStyle(0)">
          <div
            class="tsp-tax-value"
            :class="{ unknown: goPlusTax.buy === 'unknown' }"
            :style="{ color: goPlusBuyTaxColor }"
            v-if="goPlusTax.buy !== undefined && goPlusTax.buy !== null"
          >
            {{ goPlusTax.buy === 'unknown' ? $t('tokenSecurityData.unknown_tax') : goPlusTax.buy + '%' }}
          </div>
          <div class="tsp-tax-value" v-else>-</div>
        </div>
        <div class="tsp-tax-col" :style="bodyColStyle(1)" v-if="!isSol">
          <div
            class="tsp-tax-value"
            :class="{ unknown: goPlusTax.sell === 'unknown' }"
            :style="{ color: goPlusSellTaxColor }"
            v-if="goPlusTax.sell !== undefined && goPlusTax.sell !== null"
          >
            {{ goPlusTax.sell === 'unknown' ? $t('tokenSecurityData.unknown_tax') : goPlusTax.sell + '%' }}
          </div>
          <div class="tsp-tax-value" v-else>-</div>
        </div>
      </div>
    </div>

    <!-- <div class="dividing" v-if="dividing"></div> -->
    <div class="tsp-tax-body" v-if="showCertik">
      <div class="tsp-source">
        <img class="platforms" :src="certikIcon" alt="" />
        <span> {{ 'Certik' }}</span>
      </div>
      <div class="tsp-tax-col-wrapper">
        <div class="tsp-tax-col" :style="bodyColStyle(0)">
          <div
            class="tsp-tax-value"
            :class="{ unknown: certikTax.buy === 'unknown' }"
            :style="{ color: certikBuyTaxColor }"
            v-if="certikTax.buy !== undefined && certikTax.buy !== null"
          >
            {{ certikTax.buy === 'unknown' ? $t('tokenSecurityData.unknown_tax') : certikTax.buy + '%' }}
          </div>
          <div class="tsp-tax-value" v-else>-</div>
        </div>
        <div class="tsp-tax-col" :style="bodyColStyle(1)" v-if="!isSol">
          <div
            class="tsp-tax-value"
            :class="{ unknown: certikTax.sell === 'unknown' }"
            :style="{ color: certikSellTaxColor }"
            v-if="certikTax.sell !== undefined && certikTax.sell !== null"
          >
            {{ certikTax.sell === 'unknown' ? $t('tokenSecurityData.unknown_tax') : certikTax.sell + '%' }}
          </div>
          <div class="tsp-tax-value" v-else>-</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenSecurityTaxCard',
  props: {
    isSol: {
      type: Boolean,
      default: false,
    },
    queryIcon: {
      type: String,
      required: true,
    },
    goPlusIcon: {
      type: String,
      required: true,
    },
    certikIcon: {
      type: String,
      required: true,
    },
    goPlusTax: {
      type: Object,
      default: () => ({}),
    },
    certikTax: {
      type: Object,
      default: () => ({}),
    },
    goPlusBuyTaxColor: {
      type: String,
      default: '',
    },
    goPlusSellTaxColor: {
      type: String,
      default: '',
    },
    certikBuyTaxColor: {
      type: String,
      default: '',
    },
    certikSellTaxColor: {
      type: String,
      default: '',
    },
    showGoPlus: {
      type: Boolean,
      default: true,
    },
    showCertik: {
      type: Boolean,
      default: true,
    },
    dividing: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      headerColWidths: [],
      syncRafId: null,
      headerResizeObserver: null,
    };
  },
  watch: {
    isSol() {
      this.scheduleSyncHeaderColWidths();
    },
    '$i18n.locale'() {
      this.scheduleSyncHeaderColWidths();
    },
  },
  mounted() {
    this.scheduleSyncHeaderColWidths();
    window.addEventListener('resize', this.scheduleSyncHeaderColWidths, {
      passive: true,
    });

    if (typeof ResizeObserver !== 'undefined') {
      this.headerResizeObserver = new ResizeObserver(() => {
        this.scheduleSyncHeaderColWidths();
      });

      if (this.$refs.headerColWrapper) this.headerResizeObserver.observe(this.$refs.headerColWrapper);
      if (this.$refs.taxCard) this.headerResizeObserver.observe(this.$refs.taxCard);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scheduleSyncHeaderColWidths);
    if (this.headerResizeObserver) {
      this.headerResizeObserver.disconnect();
      this.headerResizeObserver = null;
    }
    if (this.syncRafId) {
      cancelAnimationFrame(this.syncRafId);
      this.syncRafId = null;
    }
  },
  methods: {
    scheduleSyncHeaderColWidths() {
      if (this.syncRafId) cancelAnimationFrame(this.syncRafId);
      this.syncRafId = requestAnimationFrame(() => {
        this.syncHeaderColWidths();
      });
    },
    syncHeaderColWidths() {
      this.$nextTick(() => {
        const wrapper = this.$refs.headerColWrapper;
        if (!wrapper) return;

        const cols = Array.from(wrapper.children).filter((el) => el?.classList?.contains('tsp-tax-col'));
        this.headerColWidths = cols.map((el) => Math.ceil(el.getBoundingClientRect().width));
      });
    },
    bodyColStyle(index) {
      const width = this.headerColWidths[index];
      if (!width) return null;

      return {
        width: `${width}px`,
        flex: `0 0 ${width}px`,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.tsp-tax-card {
  margin-top: 9px;
  border-radius: 8px;
  background: var(--bg-15);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .tsp-source {
    height: 40px;
    line-height: 40px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 500;
    color: var(--color-29);

    img {
      width: 20px;
      height: 20px;
      border-radius: 6px;
    }
  }

  .tsp-tax-header,
  .tsp-tax-body {
    padding: 0 20px 0 12px;
    display: flex;
    justify-content: space-between;
  }

  .tsp-tax-header {
    background: var(--bg-15);
    font-size: 12px;
    border-radius: 8px 8px 0 0;

    .tsp-source {
      height: 30px;
      line-height: 30px;
    }

    .tsp-tax-col {
      height: 30px;
    }
  }

  .tsp-tax-col-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
  }

  .tsp-tax-col {
    flex: 1;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;

    font-size: 12px;
    font-weight: 500;
    color: var(--color-29);
    white-space: nowrap;

    img {
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }

  .tsp-tax-body {
    background: var(--bg-40);
    border-radius: 8px;
    .tsp-tax-col {
      height: 45px;
    }
  }

  .tsp-tax-value {
    padding-right: 16px;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;

    &.unknown {
      font-size: 12px;
    }
  }
}

@media screen and (max-width: 767px) {
  .tsp-tax-card {
    padding: 16px 8px;
  }
}
</style>
